import { AssertIsNotEmptyArrayException } from './assert-is-not-empty-array.exception';
import type { NonEmptyArray } from '@pct-ts/typing';

export function assertIsNotEmptyArray<T>(
  value: unknown,
  message: string,
): asserts value is NonEmptyArray<T> {
  if (!Array.isArray(value) || value.length === 0) {
    throw new AssertIsNotEmptyArrayException(`Is a not empty array: ${message}`);
  }
}
